// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6e0045c8","977":"d312a42f"}[chunkId] + ".chunk.js";
};